module.exports = "/images/logo.svg?556979410a1db769ddeffe612eb10e4c";